
import React,  {useEffect } from "react";
import { NavLink,useLocation } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import "assets/css/Sidebar/sidebar.css"
import Logo from "assets/img/Logo.png"
import { useSelector } from 'react-redux';


var ps;
function Sidebar(props) {
  const user = useSelector(state => state.authReducer.data)
  const location = useLocation();
  const sidebar = React.useRef();


  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  // const role = localStorage.getItem("role");
  // const userRole = role
  //     ? new TextDecoder().decode(
  //         new Uint8Array(role.split(",").map(Number)).buffer
  //     )
  //     : null;

  const userRole = useSelector((state) => state.authReducer?.data?.role);



  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <div className="logo mb-2 mt-2">
        <a
          href={`/`}
        >
          <div>
            <img src={Logo} width={220} alt="liveRepSupport-logo" />
          </div>
        </a>
      </div>
      <div className="text-center">
        <p className="custom-p-sidebar"><strong>Your account ID:</strong> {user?.accountID}</p>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {props.routes?.map((prop, key) => {
            return (
              <li
                className={
                  activeRoute(prop.path) + (prop.pro ? " active-pro " : "")
                }
                // className="custom-sidebar-li"
                key={key}
              >
                <NavLink to={prop.layout + prop.path} className="nav-NavLink">
                  <i className={prop.icon} />
                  <p>{prop.name}</p>
                </NavLink>
              </li>
            );
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
